import React from 'react';

export default function PrivacyScreen() {
  return (
    <>
      <style>{`
        .privacy-page-wrapper {
          background: #f0f0f0;
          min-height: 100vh;
          width: 100%;
          padding: 40px 20px;
          color: #333;
          font-family: Georgia, serif;
          text-align: left;
        }

        .pp-wrap {
          max-width: 800px;
          margin: 0 auto;
          background: #fff;
          padding: 60px 80px;
          border-radius: 4px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }

        .pp-title {
          font-size: 32px;
          font-weight: bold;
          color: #1a1a1a;
          margin-bottom: 8px;
        }

        .pp-date {
          font-size: 14px;
          color: #666;
          margin-bottom: 30px;
        }

        .pp-intro {
          font-size: 16px;
          line-height: 1.6;
          margin-bottom: 30px;
        }

        .pp-section-title {
          font-size: 18px;
          font-weight: bold;
          color: #1a1a1a;
          margin-top: 30px;
          margin-bottom: 15px;
        }

        .pp-text {
          font-size: 16px;
          line-height: 1.6;
          margin-bottom: 15px;
        }

        .pp-list {
          list-style: disc;
          padding-left: 30px;
          margin-bottom: 20px;
        }

        .pp-list li {
          font-size: 16px;
          line-height: 1.6;
          margin-bottom: 10px;
        }

        .pp-contact-email {
          color: #1a0dab;
          text-decoration: underline;
        }

        .pp-store-note {
          margin-top: 40px;
          font-size: 14px;
          color: #555;
          padding-top: 20px;
        }

        @media (max-width: 600px) {
          .pp-wrap { padding: 30px 20px; }
          .pp-title { font-size: 24px; }
        }
      `}</style>
      <div className="privacy-page-wrapper">
        <div className="pp-wrap">
          <h1 className="pp-title">Privacy Policy for Arrow Puzzle Escape</h1>
          <div className="pp-date">
            Effective Date: April 14, 2026
          </div>

          <p className="pp-intro">
            This Privacy Policy describes how Arrow Puzzle Escape ("we," "our," or "us") collects, uses, and shares information about you when you use our mobile application (the "App").
          </p>

          <div className="pp-section-title">1. Information We Collect</div>
          <p className="pp-text">
            We only collect information that is necessary to provide and improve the App's functionality.
          </p>
          <ul className="pp-list">
            <li>
              <strong>FCM Tokens (Push Notifications):</strong> We collect your Firebase Cloud Messaging (FCM) token to send you push notifications regarding game updates, events, and reminders. These tokens are stored in our Firebase Realtime Database.
            </li>
            <li>
              <strong>In-App Review Data:</strong> We use the Google Play/App Store In-App Review API to allow you to rate the app. We do not store your rating ourselves; it is handled directly by Google/Apple.
            </li>
            <li>
              <strong>Device Information:</strong> We may collect basic device information (such as OS version and device model) to ensure the App runs correctly on your device.
            </li>
          </ul>

          <div className="pp-section-title">2. How We Use Your Information</div>
          <p className="pp-text">We use the collected information to:</p>
          <ul className="pp-list">
            <li>Send push notifications.</li>
            <li>Improve the performance and user experience of the game.</li>
            <li>Analyze usage patterns to optimize levels and challenges.</li>
          </ul>

          <div className="pp-section-title">3. Third-Party Services</div>
          <p className="pp-text">
            We use the following third-party services which may collect information according to their own privacy policies:
          </p>
          <ul className="pp-list">
            <li>
              <strong>Google Firebase:</strong> Used for analytics, crash reporting, and push notifications. <a href="https://firebase.google.com/support/privacy" className="pp-contact-email" target="_blank" rel="noopener noreferrer">Firebase Privacy Policy</a>
            </li>
            <li>
              <strong>Google Play Services / Apple App Store:</strong> Used for app distribution and in-app reviews.
            </li>
          </ul>

          <div className="pp-section-title">4. Data Retention</div>
          <p className="pp-text">
            We retain your FCM token as long as the App is installed on your device. If you uninstall the App, the token becomes invalid and will eventually be removed from our systems.
          </p>

          <div className="pp-section-title">5. Your Choices</div>
          <ul className="pp-list">
            <li>
              <strong>Push Notifications:</strong> You can opt-out of receiving push notifications at any time through your device settings.
            </li>
            <li>
              <strong>Data Access:</strong> Since we do not collect personal identifiable information (PII) like names or emails, there is no specific account data to request access to.
            </li>
          </ul>

          <div className="pp-section-title">6. Children's Privacy</div>
          <p className="pp-text">
            Our game is intended for a general audience. We do not knowingly collect personal information from children under the age of 13.
          </p>

          <div className="pp-section-title">7. Changes to This Policy</div>
          <p className="pp-text">
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
          </p>

          <div className="pp-section-title">8. Contact Us</div>
          <p className="pp-text">
            If you have any questions about this Privacy Policy, please contact us at: <br />
            <a href="mailto:hithereprofile@gmail.com" className="pp-contact-email">hithereprofile@gmail.com</a>
          </p>

          <div className="pp-store-note">
            Note: We are committed to transparency and respect your privacy while providing an engaging arrow puzzle experience.<br />
            <br />
            © 2026 Arrow Puzzle Escape. All rights reserved.
          </div>
        </div>
      </div>
    </>
  );
}
